// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
import '../../styles/containers/Party.css';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { Checkbox, FormControl } from 'react-bootstrap';
import DatePicker from '../utils/FormWidgets/DatePicker';
import Error from '../stateMessage/Error';
import {
  StyledFilterFormGroup,
  StyledFilterTitle,
  StyledFilterWrapper,
} from '../utils/Styles/FilterStyles';

class FilteredData {
  name = '';
  fromDate = '';
  active = false;
}

class State {
  filteredData = new FilteredData();
  isSuccsess = false;
  isError = false;
  isDeactive = false;
}

export default class PromoFilterForm extends React.Component {
  state = new State();

  componentDidMount() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { filteredData } = this.props;
    if (filteredData) {
      this.setState({ filteredData });
    }
  }

  componentWillUnmount() {
    this.setState({ isDeactive: true });
  }

  hideMessage = () => {
    const { isDeactive } = this.state;
    if (!isDeactive) {
      this.setState({ isError: false });
    }
  };

  handleFromDateChange = date => {
    let { filteredData } = this.state;
    let d = date;
    if (date === undefined) {
      d = '';
    }
    filteredData = {
      ...filteredData,
      fromDate: d,
    };
    this.setState({ filteredData });
    this.handleSubmit(filteredData);
  };

  handleNameChange = ({ target }) => {
    let { filteredData } = this.state;
    filteredData = {
      ...filteredData,
      name: target.value,
    };
    this.setState({ filteredData });
    this.handleSubmit(filteredData);
  };

  changeActive = () => {
    let { filteredData } = this.state;
    filteredData = {
      ...filteredData,
      active: !filteredData.active,
    };
    this.setState({ filteredData });
    this.handleSubmit(filteredData);
  };

  handleSubmit = async filteredData => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { filterPromo } = this.props;
    filterPromo(filteredData);
  };

  clear = () => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { clear } = this.props;
    this.setState({ filteredData: new FilteredData() });
    clear();
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { isMobileFilterSelected } = this.props;
    const { filteredData, isError } = this.state;
    return (
      <Fragment>
        <div
          className={`form-content col-md-10 col-sm-10 col-xs-10 horizontal-form  filter-form ${
            isMobileFilterSelected ? 'mobile-filter-selected' : ''
          }`}
          style={{ paddingLeft: '0px', paddingRight: '0px' }}
        >
          <StyledFilterTitle>Filters</StyledFilterTitle>
          <StyledFilterWrapper>
            <StyledFilterFormGroup
              style={{
                paddingLeft: '0px',
                marginTop: '-4px',
                width: '150px',
                display: 'inline-block',
                verticalAlign: 'middle',
                marginLeft: '0px',
                marginRight: '20px',
              }}
            >
              <FormControl
                type='text'
                placeholder='Code'
                onChange={this.handleNameChange}
                value={filteredData.name}
              />
            </StyledFilterFormGroup>
            <StyledFilterFormGroup
              controlId='fromDate'
              style={{
                paddingLeft: '0px',
                marginRight: '25px',
                marginTop: '-2px',
                width: '175px',
                display: 'inline-block',
                verticalAlign: 'top',
              }}
            >
              <DatePicker
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                value={filteredData.fromDate}
                handleChange={this.handleFromDateChange}
              />
            </StyledFilterFormGroup>
            <StyledFilterFormGroup
              controlId='bookable'
              style={{
                marginTop: '6px',
                verticalAlign: 'top',
                display: 'inline-block',
                width: 'auto',
              }}
            >
              <Checkbox
                inline
                onClick={this.changeActive}
                checked={filteredData.active}
              >
                <span style={{ fontSize: '18px' }}>Active</span>
              </Checkbox>
            </StyledFilterFormGroup>
            <button
              type='button'
              onClick={this.clear}
              className='btn btn-def panel-button'
              style={{ marginLeft: '30px' }}
            >
              Clear all
            </button>
          </StyledFilterWrapper>
          {isError && <Error text='server error' />}
        </div>
      </Fragment>
    );
  }
}
